<script context="module" lang="ts">
	export const ToolPosition = {
		Left: 'left',
		TL: 'top-left',
		TC: 'top-center',
		TR: 'top-right',
		Right: 'right',
		BR: 'bottom-right',
		BC: 'bottom-center',
		BL: 'bottom-left'
	}
	export type ToolPositionOption = typeof ToolPosition[keyof typeof ToolPosition];
</script>

<script lang="ts">
	export let pos: ToolPositionOption;
	export let message: string;
	export let noArrow = false; // Use the 'noArrow' attribute in the component, if you don't want the arrow to show
	export let short = false;

</script>

<article class="tooltip {pos}" class:short class:noArrow>
	<slot/>
	{message}
</article>

<style lang="scss">
	@use 'color';
	:global(*) > .tooltip {
		display: none;
	}
	:global(*):hover > .tooltip,
	:global(*):active > .tooltip {
		display: block;
	}
	.tooltip {
		position: absolute;
		width: max-content;
		background: color.$on-background-high-importance;
		color: color.$surface;
		padding: 4px 6px;
		border-radius: 8px;
		font-size: .88rem;
		font-weight: 500;
		white-space: initial;
		display: none;
		&:before {
			position: absolute;
			width: 10px;
			height: 10px;
			border: 6px solid transparent;
			border-bottom-width: 0;
    	border-top-color: color.$on-background-high-importance;
			content: '';
			transform: rotate(45deg);
			display: none;
		}
		&.noArrow {
			&:before {display: none !important;}
		}
		// Dynamically set
		&.left { 
			right: calc(100% + 10px); 
			bottom: 50%;
			transform: translate(0, calc(100% + -1rem));
			top: unset; 
			left: unset;
			&:before {
				transform: rotate(270deg) translate(5px, -1px);
				top: 50%;
				left: 100%;
				display: block;
			}
		}
		&.top-left { 
			bottom: calc(100% + 2px); 
			right: calc(100% + 2px);
			left: unset;
			top: unset;
			border-radius: 8px 8px 0 8px;
		}
		&.top-center {
			bottom: calc(100% + 10px);
			left: 50%;
			top: unset;
			right: unset;
			transform: translate(-50%, 0);
			max-width: 100%;
			&:before {
				transform: rotate(0deg) translate(50%, 0px);
				top: 100%;
				right: 50%;
				display: block;
			}
		}
		&.top-right {
			bottom: calc(100% + 2px); 
			left: calc(100% + 2px);
			top: unset;
			right: unset;
			border-radius: 8px 8px 8px 0;
		}
		&.right {
			left: calc(100% + 10px); 
			bottom: 50%;
			transform: translate(0, calc(100% + -1rem));
			top: unset; 
			right: unset;
			&:before {
				transform: rotate(90deg) translate(-4px, -1px);
				top: 50%;
				right: 100%;
				display: block;
			}
		}
		&.bottom-right {
			top: calc(100% + 2px); 
			left: calc(100% + 2px);
			bottom: unset;
			right: unset;
			border-radius: 0 8px 8px 8px;
		}
		&.bottom-center {
			top: calc(100% + 10px);
			left: 50%;
			bottom: unset;
			right: unset;
			transform: translate(-50%, 0);
			&:before {
				transform: rotate(180deg) translate(-50%, 0px);
				bottom: 100%;
				right: 50%;
				display: block;
			}
		}
		&.bottom-left { 
			top: calc(100% + 2px); 
			right: calc(100% + 2px);
			left: unset;
			bottom: unset;
			border-radius: 8px 0 8px 8px;
		}
		&.short {
			max-width: 270px;
		}
	}
</style>

